"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SideNavigationItem = _interopRequireDefault(require("./SideNavigationItem"));
var _utils = require("../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const generateItem = (item, index, linkComponent, dark) => {
  if ((0, _utils.isReactNode)(item)) {
    return /*#__PURE__*/_react.default.createElement(_SideNavigationItem.default, {
      key: index
    }, item);
  }
  if ("nonInteractive" in item) {
    var _item$dark;
    return /*#__PURE__*/_react.default.createElement(_SideNavigationItem.default, _extends({}, item, {
      dark: (_item$dark = item.dark) !== null && _item$dark !== void 0 ? _item$dark : dark,
      key: index
    }));
  }
  if ("children" in item) {
    return /*#__PURE__*/_react.default.createElement(_SideNavigationItem.default, _extends({
      key: index
    }, item));
  }
  if ("label" in item) {
    var _item$component, _item$dark2;
    return /*#__PURE__*/_react.default.createElement(_SideNavigationItem.default, _extends({
      component: (_item$component = item.component) !== null && _item$component !== void 0 ? _item$component : linkComponent,
      dark: (_item$dark2 = item.dark) !== null && _item$dark2 !== void 0 ? _item$dark2 : dark
    }, item, {
      key: index
    }));
  }
  return null;
};
const generateItems = (groups, listClassName, linkComponent, dark) => {
  return groups === null || groups === void 0 ? void 0 : groups.filter(Boolean).map((group, g) => {
    let items;
    let props = {};
    if (typeof group === "object" && "items" in group) {
      ({
        items,
        ...props
      } = group);
    } else {
      items = group;
    }
    return /*#__PURE__*/_react.default.createElement("ul", _extends({}, props, {
      className: (0, _classnames.default)("p-side-navigation__list", listClassName, "className" in group ? group.className : null),
      key: g
    }), items.filter(Boolean).map((item, i) => generateItem(item, i, linkComponent, dark)));
  });
};
const getHasIcons = groups => groups === null || groups === void 0 ? void 0 : groups.some(group => {
  var _ref;
  return group && ((_ref = "items" in group ? group.items : group) === null || _ref === void 0 ? void 0 : _ref.some(item => (0, _utils.isReactNode)(item) ? false : item && "icon" in item && !!item.icon));
});

/**
 * This is a [React](https://reactjs.org/) component for side navigation, used
 * in the [Vanilla](https://vanillaframework.io/docs/) layouts.
 */
const SideNavigation = _ref2 => {
  let {
    children,
    className,
    dark,
    hasIcons,
    items,
    linkComponent,
    listClassName,
    navClassName,
    ...props
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)(className, {
      "p-side-navigation--icons": hasIcons || getHasIcons(items),
      "is-dark": dark
    })
  }, props), /*#__PURE__*/_react.default.createElement("nav", {
    className: navClassName
  }, children !== null && children !== void 0 ? children : generateItems(items, listClassName, linkComponent, dark)));
};
var _default = exports.default = SideNavigation;